
const getMapExtentFromCenter = (centerLat, centerLng, zoom, mapWidth = 800, mapHeight = 600) => {
    const metersPerPixel = 156543.03392 * Math.cos(centerLat * Math.PI / 180) / Math.pow(2, zoom);

    const halfMapWidthMeters = (mapWidth / 2) * metersPerPixel;
    const halfMapHeightMeters = (mapHeight / 2) * metersPerPixel;

    const earthCircumference = 40075016.686;
    const degreesPerMeterLng = 360 / earthCircumference;
    const degreesPerMeterLat = 360 / earthCircumference;

    const deltaLng = halfMapWidthMeters * degreesPerMeterLng;
    const deltaLat = halfMapHeightMeters * degreesPerMeterLat;

    return {
        xmin: centerLng - deltaLng,
        ymin: centerLat - deltaLat,
        xmax: centerLng + deltaLng,
        ymax: centerLat + deltaLat,
    };
};

export default getMapExtentFromCenter;
